export const ReportingCacheReserializeComponent = {
    MountAsync: async (target: HTMLElement, props: {}) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ReportingCacheReserializeComponent } = await import('./ReportingCacheReserializeComponent');
        return await mountReactComponentAsync(target, ReportingCacheReserializeComponent, props);
    }
};
